import * as Sentry from '@sentry/vue';
import { Vue } from '@sentry/vue/types/types';
import VueRouter from 'vue-router';

export const useSentry = (app: Vue | Vue[], router: VueRouter, appTag = 'frontend') => {
    const sentryEnabled = shouldEnableSentry();
    if (!sentryEnabled) {
        return;
    }

    const sentryDSN = process.env.VUE_APP_SENTRY_DSN ? String(process.env.VUE_APP_SENTRY_DSN) : '';
    const sentryTraceSampleRate = process.env.VUE_APP_SENTRY_TRACE_SAMPLE_RATE
        ? Number(process.env.VUE_APP_SENTRY_TRACE_SAMPLE_RATE)
        : 1;
    const sentryEnvironment = process.env.VUE_APP_SENTRY_ENVIRONMENT
        ? String(process.env.VUE_APP_SENTRY_ENVIRONMENT)
        : 'local';

    // todo: update sentry
    // noinspection JSDeprecatedSymbols
    Sentry.init({
        app,
        environment: sentryEnvironment,
        dsn: sentryDSN,
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            }),
        ],
        tracesSampleRate: sentryTraceSampleRate,
    });

    Sentry.setTag('app', appTag);
};

export const setSentryUserId = (id: string | number) => {
    Sentry.setUser({
        id: String(id),
    });
};

const shouldEnableSentry = () => {
    const envEnabled = process.env.VUE_APP_SENTRY_ENABLED;
    if (!envEnabled) {
        return false;
    }

    if (typeof envEnabled === 'string') {
        return envEnabled ? ['1', 'true'].includes(envEnabled) : false;
    } else if (typeof envEnabled === 'boolean') {
        return envEnabled;
    } else {
        return false;
    }
};
